import { from, timer } from 'rxjs';
import { exhaustMap, map } from 'rxjs/operators';
import type { Epic } from 'redux-observable';

import BuildActions from './actions';

const BUILD_POLL_INTERVAL = 3000;

const pollBuildsEpic: Epic = (_action$, state$) =>
  timer(0, BUILD_POLL_INTERVAL).pipe(
    exhaustMap(() =>
      from(state$.value.builds.watchedBuilds).pipe(
        map(BuildActions.fetchOne),
      ),
    ),
  );

export default pollBuildsEpic;
